import { render, staticRenderFns } from "./UpdateInformation.vue?vue&type=template&id=361e5224&scoped=true&"
import script from "./UpdateInformation.vue?vue&type=script&lang=js&"
export * from "./UpdateInformation.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInformation.vue?vue&type=style&index=0&id=361e5224&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e5224",
  null
  
)

export default component.exports